import axios from 'axios'
import { LISTAR_FILTROS_CTE_OS } from '../types'
import { URL } from '../../util/ambienteActions';

export default function listarFiltrosCteOs (idEmpresa) {
  const url = `${URL}/itinerario/empresa/${idEmpresa}/filtros`

  return dispatch => axios.get(url).then(
      response => dispatch({
        type: LISTAR_FILTROS_CTE_OS,
        payload: response

      })
  );
}